export enum PanelActionTypes {
    API_RESPONSE_SUCCESS = '@@auth/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@auth/API_RESPONSE_ERROR',

    SEND_GLOBAL_MESSAGE = '@@panel/SEND_GLOBAL_MESSAGE',

    RESET = '@@auth/RESET',
}
